import * as React from 'react';

function Surfing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M8.88 16.608c.497.381.885 1.072 1.148 2.11l.056.237.047.221.017.073c-2.213 1.38-4.206 2.024-5.551 1.643l4.282-4.284zM19.882 3.303L3.303 19.883c-.807-1.469.046-4.038 1.998-6.866l.155-.22.314-.435c.387-.524.808-1.054 1.263-1.584l.346-.4.4-.441A35.06 35.06 0 019.567 8.12l.369-.344.443-.398a30.134 30.134 0 011.588-1.313l.394-.296.434-.315c2.914-2.06 5.58-2.98 7.086-2.152zM12.068 13.42c2.442 2.443-.358 8.219-1.044 5.45-.456-1.847-.851-2.778-1.185-2.794l-.21-.21-.003-.003 2.442-2.443zm8.824-8.824c.429 1.511-.438 3.844-2.193 6.387l-.155.22-.314.434a28.8 28.8 0 01-1.262 1.585l-.347.398-.4.442a35.019 35.019 0 01-1.789 1.816l-.369.344-.03.027a5.674 5.674 0 00-1.32-3.474l8.179-8.18z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Surfing;
